import "./index.css";

export function Copyright() {
  return (
    <div className="d-flex justify-content-between align-items-center gap-2">
      <div className="text-center">
        {`Copyright 2021-${new Date().getFullYear()} © `}
        <b>
          <a
            href="https://www.cciahn.com"
            className="copy"
            target="_blank"
            rel="noreferrer"
          >
            Cámara de Comercio e Industrias de Atlántida
          </a>
        </b>
      </div>
    </div>
  );
}
